import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';

function Stars() {
  const canvasRef = useRef(null);
  const cameraRef = useRef(new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
  ));
  const mouseX = useRef(0);
  const mouseY = useRef(0);
  const rendererRef = useRef(null);
  const raycasterRef = useRef(null);
  var starPositions = useRef(new Float32Array(1000 * 3));
  let starsAdded = useRef(false);
  let stars = useRef(null);

  const handleMouseMove = (event) => {
    mouseX.current = (event.clientX - window.innerWidth / 2) / 100;
    mouseY.current = (event.clientY - window.innerHeight / 2) / 100;
    const mouse = {
      x: (event.clientX / rendererRef.current.domElement.clientWidth) * 2 - 1,
      y: -(event.clientY / rendererRef.current.domElement.clientHeight) * 2 + 1,
    };

    raycasterRef.current.setFromCamera(mouse, cameraRef.current);
  };

  const containerStyle = {
    position: 'fixed',
    zIndex: '-1',
  };

  useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000
    );
    cameraRef.current = camera;
    const raycaster = new THREE.Raycaster();
    raycasterRef.current = raycaster;
    const renderer = new THREE.WebGLRenderer({ antialias: true });

    renderer.setSize(window.innerWidth, window.innerHeight);
    canvasRef.current.appendChild(renderer.domElement);

    rendererRef.current = renderer;

    //               /$$                                  
    //              | $$                                  
    //    /$$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$   /$$$$$$$
    //   /$$_____/|_  $$_/   |____  $$ /$$__  $$ /$$_____/
    //  |  $$$$$$   | $$      /$$$$$$$| $$  \__/|  $$$$$$ 
    //   \____  $$  | $$ /$$ /$$__  $$| $$       \____  $$
    //   /$$$$$$$/  |  $$$$/|  $$$$$$$| $$       /$$$$$$$/
    //  |_______/    \___/   \_______/|__/      |_______/ 
    //                                                    
    //                                                    
    //                                                    
                                                    
        
    // Create a custom shader material for the point cloud
    const starLoader = new THREE.TextureLoader();
    starLoader.load("/img/star_2.png",
    function ( texture ) {    
    // Create the stars as a point cloud
    var starsGeometry = new THREE.BufferGeometry();
    for (var i = 0; i < 1000; i++) {
        starPositions.current[i * 3 + 0] = (Math.random() - 0.5) * 500;
        starPositions.current[i * 3 + 1] = (Math.random() - 0.5) * 500;
        starPositions.current[i * 3 + 2] = (Math.random() - 0.5) * 500;
    }
    starsGeometry.setAttribute('position', new THREE.BufferAttribute(starPositions.current, 3));
    var starsMaterial = new THREE.PointsMaterial({ color: 0xffffff, size: 2.0,
            map: texture,
            //blending: THREE.AdditiveBlending,
            depthTest: false,
            transparent: true 
        });
    stars.current = new THREE.Points(starsGeometry, starsMaterial);
    scene.add(stars.current);
    starsAdded.current = true;
    console.log(stars.current);
    });

    //               /$$                                  
    //              | $$                                  
    //    /$$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$   /$$$$$$$
    //   /$$_____/|_  $$_/   |____  $$ /$$__  $$ /$$_____/
    //  |  $$$$$$   | $$      /$$$$$$$| $$  \__/|  $$$$$$ 
    //   \____  $$  | $$ /$$ /$$__  $$| $$       \____  $$
    //   /$$$$$$$/  |  $$$$/|  $$$$$$$| $$       /$$$$$$$/
    //  |_______/    \___/   \_______/|__/      |_______/ 
    //                                                    
    //                                                    
    // 
    
    // Animate the stars based on mouse movement                                                                                


    renderer.render( scene, cameraRef.current );        


    // Animate the stars based on mouse movement
    const animate = () => {
      requestAnimationFrame(animate);

      if(starsAdded.current){
        stars.current.rotation.z += 0.001;
      }

      // Update your scene here using mouseX.current and mouseY.current

      rendererRef.current.render(scene, cameraRef.current);
    };

    animate();

    // Clean up
    return () => {
      renderer.dispose();
    };
  }, []);

  return (
    <div onMouseMove={handleMouseMove} style={containerStyle} ref={canvasRef}></div>
  );
}

export default Stars;
